import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { SubmissionSlotData } from "types/SubmissionSlots";

import { AppDispatch } from "store/store";

import {
  initialize,
  setCurrentSubmissionSlotData,
  setDataTaskPreviousState,
  setEnableLoading,
  setIsSaveVisible,
  setIsSubmitVisible,
  setPristine,
  setStatus,
  setSurveyData,
  setValidationStatus,
} from "./submissionSlotDetailsStore";
import { SurveyData, ValidationStatus } from "./types";

export interface UseSubmissionSlotDetailsSetters {
  initialize: () => void;
  setCurrentSubmissionSlotData: (data?: SubmissionSlotData) => void;
  setEnableLoading: (enable: boolean) => void;
  setPristine: (pristine: boolean) => void;
  setIsSubmitVisible: (isVisible: boolean) => void;
  setIsSaveVisible: (isVisible: boolean) => void;
  setValidationStatus: (status: ValidationStatus) => void;
  setSurveyData: (data: SurveyData) => void;
  setStatus: (status?: string) => void;
  setDataTaskPreviousState: (state: boolean) => void;
}

export const useSubmissionSlotDetailsStore =
  (): UseSubmissionSlotDetailsSetters => {
    const dispatch = useDispatch<AppDispatch>();

    return {
      initialize: useCallback(() => dispatch(initialize()), [dispatch]),

      setCurrentSubmissionSlotData: useCallback(
        (data?: SubmissionSlotData) =>
          dispatch(setCurrentSubmissionSlotData(data ?? null)),
        [dispatch]
      ),

      setEnableLoading: useCallback(
        (enable: boolean) => dispatch(setEnableLoading(enable)),
        [dispatch]
      ),

      setPristine: useCallback(
        (pristine: boolean) => dispatch(setPristine(pristine)),
        [dispatch]
      ),

      setIsSubmitVisible: useCallback(
        (isVisible: boolean) => dispatch(setIsSubmitVisible(isVisible)),
        [dispatch]
      ),

      setIsSaveVisible: useCallback(
        (isVisible: boolean) => dispatch(setIsSaveVisible(isVisible)),
        [dispatch]
      ),

      setValidationStatus: useCallback(
        (status: ValidationStatus) => dispatch(setValidationStatus(status)),
        [dispatch]
      ),

      setSurveyData: useCallback(
        (data: SurveyData) => dispatch(setSurveyData(data)),
        [dispatch]
      ),

      setStatus: useCallback(
        (status?: string) => dispatch(setStatus(status)),
        [dispatch]
      ),

      setDataTaskPreviousState: useCallback(
        (state: boolean) => dispatch(setDataTaskPreviousState(state)),
        [dispatch]
      ),
    };
  };
